// extracted by mini-css-extract-plugin
export default {"pageREVI":"Page_REVI_pageREVI__lX7A4","tabsWrapper":"Page_REVI_tabsWrapper__4re5A"};